const moduleMap = {
	"./useDialogPopup": () => {
		return Promise.all([__webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(1941)]).then(() => (() => ((__webpack_require__(1941)))));
	},
	"./dialogProvider": () => {
		return Promise.all([__webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(763)]).then(() => (() => ((__webpack_require__(3144)))));
	},
	"./dialogPopup": () => {
		return Promise.all([__webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(5514)]).then(() => (() => ((__webpack_require__(5514)))));
	},
	"./userProvider": () => {
		return Promise.all([__webpack_require__.e(9703), __webpack_require__.e(8110), __webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(7505), __webpack_require__.e(6731), __webpack_require__.e(6098)]).then(() => (() => ((__webpack_require__(6098)))));
	},
	"./logo": () => {
		return __webpack_require__.e(4839).then(() => (() => ((__webpack_require__(4839)))));
	},
	"./login": () => {
		return Promise.all([__webpack_require__.e(9703), __webpack_require__.e(8110), __webpack_require__.e(8610), __webpack_require__.e(8278), __webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(7505), __webpack_require__.e(6731), __webpack_require__.e(4945), __webpack_require__.e(5034), __webpack_require__.e(8536), __webpack_require__.e(8380)]).then(() => (() => ((__webpack_require__(1900)))));
	},
	"./configurationProvider": () => {
		return Promise.all([__webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(7505), __webpack_require__.e(931)]).then(() => (() => ((__webpack_require__(931)))));
	},
	"./languageProvider": () => {
		return Promise.all([__webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(7505), __webpack_require__.e(5034), __webpack_require__.e(905)]).then(() => (() => ((__webpack_require__(905)))));
	},
	"./withConfiguration": () => {
		return Promise.all([__webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(7505), __webpack_require__.e(8810)]).then(() => (() => ((__webpack_require__(8810)))));
	},
	"./withUser": () => {
		return Promise.all([__webpack_require__.e(9703), __webpack_require__.e(8110), __webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(7505), __webpack_require__.e(6731), __webpack_require__.e(8495)]).then(() => (() => ((__webpack_require__(8495)))));
	},
	"./withCustomTheme": () => {
		return Promise.all([__webpack_require__.e(5641), __webpack_require__.e(4945), __webpack_require__.e(1903)]).then(() => (() => ((__webpack_require__(1903)))));
	},
	"./userModel": () => {
		return __webpack_require__.e(8194).then(() => (() => ((__webpack_require__(8194)))));
	},
	"./webSocket": () => {
		return Promise.all([__webpack_require__.e(9703), __webpack_require__.e(8110), __webpack_require__.e(5641), __webpack_require__.e(6818), __webpack_require__.e(7505), __webpack_require__.e(6731), __webpack_require__.e(3283), __webpack_require__.e(396)]).then(() => (() => ((__webpack_require__(396)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});